<template>
  <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.5,15.5h-13 c-0.552,0-1-0.448-1-1v-13c0-0.552,0.448-1,1-1h13c0.552,0,1,0.448,1,1v13C15.5,15.052,15.052,15.5,14.5,15.5z"
      fill="none"
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    />
    <polyline fill="none" points="15.5,9.5 10.5,9.5 10.5,12.5 5.5,12.5 5.5,9.5 0.5,9.5 " stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
  </svg>
</template>
